// @flow
import React from 'react';
import { get, find, sum } from 'lodash';
import { compose, pure } from 'recompose';
import { Row, Col } from 'angieslist-react-components';
import { urlCatalog } from 'angieslist-app-platform';
import CustomerContactsChart from './CustomerContactsChart';
import './PerformanceViewHeader.scss';

const calculateContactsPercentage = (contactCount, contactTotal) =>
  ((contactTotal > 0) ? (contactCount / contactTotal) * 100 : 0);

const PerformanceViewHeaderComponent = (PerformanceViewHeaderProps) => {
  const {
    serviceProviderId,
    contactMetrics,
    isAdvertiser,
  } = PerformanceViewHeaderProps;

  const typeMetrics = get(contactMetrics, 'contactTypeMetrics', {});

  const callsMetrics = find(typeMetrics, o => o.contactType === 'Calls');
  const estimatedCallsMetrics = find(typeMetrics, o => o.contactType === 'Estimated Calls');
  const quotesMetrics = find(typeMetrics, o => o.contactType === 'RequestAQuote');
  const messagesMetrics = find(typeMetrics, o => o.contactType === 'MessageSent');
  const dealsMetrics = find(typeMetrics, o => o.contactType === 'DealClaimed');

  const callCount = get(callsMetrics, 'contactCount', 0);
  const estimatedCallCount = get(estimatedCallsMetrics, 'contactCount', 0);
  const quoteRequestsCount = get(quotesMetrics, 'contactCount', 0);
  const messagesCount = get(messagesMetrics, 'contactCount', 0);
  const claimedDealsCount = get(dealsMetrics, 'contactCount', 0);

  const totalCount = sum([
    callCount, estimatedCallCount, quoteRequestsCount, messagesCount, claimedDealsCount]);

  return (
    <div id={`performance-view-header-${serviceProviderId}`} className="performance-view-header-wrapper">
      <Row>
        <Col xs={12} sm={3} className="performance-view-header-section contacts">
          <div className="contact-box">
            <h4>Customer Contacts</h4>
            <h1>{contactMetrics ? contactMetrics.aggregatedContactCount : 0}</h1>
            <div className="last-90-days">
              Last 90 days
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} className="performance-view-header-section chart">
          <CustomerContactsChart
            totalToDisplay={contactMetrics ? contactMetrics.aggregatedContactCount : 0}
            callsPercentage={calculateContactsPercentage(
              (callCount + estimatedCallCount),
              totalCount,
            )}
            trackedCallsPercentage={calculateContactsPercentage(
              callCount,
              (callCount + estimatedCallCount),
            )}
            quoteRequestsPercentage={calculateContactsPercentage(quoteRequestsCount, totalCount)}
            messagesPercentage={calculateContactsPercentage(messagesCount, totalCount)}
            claimedDealsPercentage={calculateContactsPercentage(claimedDealsCount, totalCount)}
            strokeWidth={7}
            serviceProviderId={serviceProviderId}
            isAdvertiser={isAdvertiser}
          />
        </Col>
        <Col xs={12} sm={3} className="performance-view-header-section misc">
          <div className="pro-tip">
            <strong>Pro Tip: </strong> Refine your service area to get requests in the
            areas you want. <br />
            <a
              id="add-service-areas-link"
              href={urlCatalog.office.spProfile.serviceAreas(serviceProviderId)}
            >
              Add Service Areas
            </a>
          </div>
          <div className="calls-explanation">
            <strong>How we know about phone calls</strong>
            <p>
              Customers are required to click to reveal your phone number, and this
              lets us know what categories they are likely contacting you about. This
              data helps us estimate what categories your calls were about.
            </p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default((compose(pure)(PerformanceViewHeaderComponent): any));



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/PerformanceViewHeader.js